import { Directive, Input, HostListener } from '@angular/core';
import { AbstractControl } from '@angular/forms';

/**
 * Directive that allows selecting or deselecting all options in a multi-select form control.
 * When the special 'selectAllValue' is selected, all options are selected. If all options
 * are already selected, selecting 'selectAllValue' will deselect all.
 */
@Directive({
  selector: '[appSelectAll]'
})
export class SelectAllDirective {
  @Input('appSelectAll') set optionsInput(val: { value: string; label: string }[] | null | undefined) {
    this.options = val ?? [];
  }
  options: { value: string; label: string }[] = [];
  @Input() control: AbstractControl | null = null;
  @Input() selectAllValue: string = 'SELECT_ALL';

  @HostListener('ngModelChange', ['$event'])
  onModelChange(selectedValues: any): void {
    if (!this.control || !selectedValues) return;

    // Ensure selectedValues is always an array for following logic
    const selectedArray: string[] = Array.isArray(selectedValues)
      ? selectedValues
      : [selectedValues];

    const allValues = this.options.map(option => option.value);
    if (selectedArray.includes(this.selectAllValue)) {
      const allSelected = allValues.every(value => selectedArray.includes(value));
      const newValues = allSelected ? [] : allValues;
      this.control.setValue(newValues);
    }
  }
}